<div class="done_container" *ngIf="isVisible" [@doneAnimation]>
  <div class="content">
    <mat-icon class="notranslate">done</mat-icon>
    <h1>{{ 'COMPONENTS.DONE' | translate }}!</h1>
  </div>
</div>
